document.addEventListener('click', function(e) {
    if (e.target.closest('.more-filter')) {  // checks if the click was inside .more-filter
        const accordions = document.querySelectorAll('.accordion');
        accordions.forEach(function(accordion) {
            accordion.classList.remove('hidden');
        });
        console.log('work'); // optional for debugging
    }
});
document.addEventListener("click", (event) => {
  const isInsideAccordion = event.target.closest("accordion-disclosure");

  if (!isInsideAccordion) {
    const all = document.querySelectorAll("accordion-disclosure");

    all.forEach((el) => {
      const details = el.querySelector("details");
      const content = el.querySelector(".accordion__content");

      if (details?.hasAttribute("open")) {
        details.removeAttribute("open");
        details.setAttribute("aria-expanded", "false");

        if (content) {
          content.removeAttribute("style");
        }
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".feature-badge").forEach(function (badge) {
    const pTag = badge.querySelector("p");
    if (!pTag || !pTag.textContent.trim()) {
      badge.style.display = "none"; // hide if <p> is missing or empty
    } else {
      badge.style.display = ""; // show if <p> has content
    }
  });
});

  document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.collection-menu');
    const toolbar = document.querySelector('height-observer.collection-toolbar');
    if (menu && toolbar && menu.children.length === 0) {
      toolbar.classList.add('is-empty');
    }
  });